/**
 * Extract digits from a string and return exactly 7 digits if valid, or empty string.
 * Useful for parsing IMO numbers from free-text fields like general remarks.
 *
 * @param {string} value
 * @returns {string} 7-digit string or ''
 */
export const parseImoDigits = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  // Accept exactly 7 digits, or 7 leading digits from a longer string
  return digits.length >= 7 ? digits.slice(0, 7) : '';
};

/**
 * Normalize an IMO value to the canonical database format `IMO` + 7 digits.
 * Returns null when the input does not contain 7 valid digits.
 *
 * @param {string} value
 * @returns {string|null} e.g. 'IMO1234567' or null
 */
export const normalizeImo = (value) => {
  const digits = parseImoDigits(value);
  return digits.length === 7 ? `IMO${digits}` : null;
};

/**
 * Validate that a value can be normalized to a valid IMO.
 *
 * @param {string} value
 * @returns {boolean}
 */
export const isValidImo = (value) => normalizeImo(value) !== null;
